import { initCarousel } from '../../_shared/carousel';

initCarousel('destinations-slider');
